import { render, staticRenderFns } from "./WeeklyPlan.vue?vue&type=template&id=357fd404&scoped=true&"
import script from "./WeeklyPlan.vue?vue&type=script&lang=js&"
export * from "./WeeklyPlan.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyPlan.vue?vue&type=style&index=0&id=357fd404&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357fd404",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/c/Users/wbreu/Documents/code/personal/the-unit-planner/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('357fd404', component.options)
    } else {
      api.reload('357fd404', component.options)
    }
    module.hot.accept("./WeeklyPlan.vue?vue&type=template&id=357fd404&scoped=true&", function () {
      api.rerender('357fd404', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/WeeklyPlan.vue"
export default component.exports